module.exports = __webpack_public_path__ + "static/media/map-marked-alt.2b773941.svg";